export default "__VITE_ASSET__DS3vG_R8__"